import React, { Component } from 'react'
import './Projects.css'
import Deck from '../Card/Card'
import Swipe from '../shared/swipe/Swipe'

export default class Projects extends Component {
    render() {
        return (
            <div id= "project" className="projects">
                <div className="projects-tittle">
                    <h4>Projects</h4>
                    <h5> A selection of my projects </h5>
                </div>
                <div className="projects-swipe-container">
                    <Swipe/>
                    <span > swipe to see more </span>     
                </div>
                
                <div className="projects-cards-containers">

                 <Deck/>

                </div>

            </div>
        )
    }
}
